import React from 'react';
import { Box, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ReviewSourceDisplay } from 'component/page/detail/Review/Review.selectors';
import { getTranslatedMonthYear } from 'core-framework/util/datetime/date';

interface OwnProps {
    authorName: string;
    reviewDate: string;
    reviewSource: ReviewSourceDisplay;
}

type Props = OwnProps;

const ReviewCardHeader: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    const reviewDate = props.reviewDate && StringFormatter.format(cms[272057], getTranslatedMonthYear(cms, props.reviewDate), props.reviewSource);

    return (
        <Box display="flex" flexDirection="row">
            {props.authorName && (
                <Box
                    borderRadius="base"
                    backgroundColor="deprecated.neutral.4"
                    width="40px"
                    height="40px"
                    textAlign="center"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    me="12"
                >
                    <Typography variant="body-default-strong" textColor="base.subtle">
                        {props.authorName[0]}
                    </Typography>
                </Box>
            )}
            <Box display="flex" flexDirection="column" justifyContent="space-evenly">
                {props.authorName && (
                    <Typography tag="h3" variant="caption-default-strong" textColor="base.subtle" display="block">
                        {props.authorName}
                    </Typography>
                )}
                {reviewDate && (
                    <Typography variant="caption-default" textColor="base.subtle" display="block">
                        {reviewDate}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

ReviewCardHeader.displayName = 'ReviewCardHeader';
export default ReviewCardHeader;
